import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const getCountry = createAsyncThunk(
    "country/getCountry",
    async ({ makeId }, { rejectWithValue }) => {
        try {

            const params = {
                ...(makeId != null && { makeId }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/country`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);
